export function fmtMoney(n: number | null | undefined, opts?: { decimals?: number; sign?: boolean }): string {
  if (n == null || !isFinite(n)) return '—';
  const decimals = opts?.decimals ?? 0;
  const sign = opts?.sign ? (n > 0 ? '+' : n < 0 ? '−' : '') : '';
  const abs = Math.abs(n);
  const parts = abs.toLocaleString(undefined, {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  const base = `$${parts}`;
  if (opts?.sign) return `${sign}${base.replace('$', '$')}`;
  if (n < 0) return `−${base}`;
  return base;
}

export function fmtCompact(n: number | null | undefined): string {
  if (n == null || !isFinite(n)) return '—';
  const abs = Math.abs(n);
  if (abs >= 1_000_000) return `${(n / 1_000_000).toFixed(abs >= 10_000_000 ? 1 : 2)}M`;
  if (abs >= 1_000) return `${(n / 1_000).toFixed(abs >= 10_000 ? 0 : 1)}K`;
  return n.toFixed(0);
}

export function fmtPct(n: number | null | undefined, decimals = 1): string {
  if (n == null || !isFinite(n)) return '—';
  return `${(n * 100).toFixed(decimals)}%`;
}

export function parseMoney(input: string): number {
  if (!input) return 0;
  const cleaned = input.replace(/[$,\s_]/g, '').replace(/[−–]/g, '-');
  const n = Number(cleaned);
  return isFinite(n) ? n : 0;
}

export function todayIso(): string {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function fmtDate(iso: string): string {
  if (!iso) return '';
  const [y, m, d] = iso.split('-').map(Number);
  const dt = new Date(y, m - 1, d);
  return dt.toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  });
}

export function relativeDate(iso: string): string {
  const now = Date.now();
  const t = new Date(iso).getTime();
  const diffDays = Math.round((now - t) / (1000 * 60 * 60 * 24));
  if (Math.abs(diffDays) < 1) return 'today';
  if (diffDays === 1) return 'yesterday';
  if (diffDays > 0 && diffDays < 30) return `${diffDays}d ago`;
  if (diffDays >= 30 && diffDays < 365) return `${Math.round(diffDays / 30)}mo ago`;
  if (diffDays >= 365) return `${Math.round(diffDays / 365)}y ago`;
  return fmtDate(iso);
}
